import { Token } from "@0xsquid/squid-types";
import { create } from "zustand";
import { TransactionErrorWithMessage } from "../../core/types/error";

export type SendTransaction = {
  txHash: string;
  to: string;
  token: Token;
  amount: string;
};

type TransactionState = SendTransaction & {
  error?: TransactionErrorWithMessage;
};

interface SendTransactionStore {
  txLocalId?: string;
  transactions: Record<string, TransactionState>;
  currentTransaction?: TransactionState;
  setTransactionState: (
    id: string | undefined,
    transaction: TransactionState
  ) => void;
  getTransaction: (id: string) => TransactionState | undefined;
}

export const useSendTransactionStore = create<SendTransactionStore>(
  (set, get) => ({
    txLocalId: undefined,
    transactions: {},
    currentTransaction: undefined,
    setTransactionState(txId, tx) {
      if (!txId) return;

      set((state) => {
        const newTransactions = { ...state.transactions, [txId]: tx };

        return {
          transactions: newTransactions,
          currentTransaction:
            txId === state.txLocalId ? tx : state.currentTransaction,
        };
      });
    },
    getTransaction(id) {
      return get().transactions[id];
    },
  })
);
